module.exports = __webpack_public_path__ + "img/income_rate-true.717a4bfe.png";